<div class="container-fluid">
  <div class="card">
    <div class="card-header d-flex justify-content-between align-items-center">
      <h5 class="mb-0">Message Templates</h5>
      <div>
        <button class="btn btn-outline-secondary btn-sm me-2" (click)="loadTemplates()" [disabled]="loading">
          {{ loading ? 'Refreshing...' : 'Refresh' }}
        </button>
        <button class="btn btn-outline-primary btn-sm me-2" (click)="toggleForm()">
          {{ showForm ? 'Close' : 'Add New Template' }}
        </button>
        <button class="btn btn-primary btn-sm" (click)="setupCampaign()">Setup a Campaign</button>
      </div>
    </div>

    <div class="card-body">

      <!-- Add template form -->
      <div class="border rounded p-3 mb-4 bg-light" *ngIf="showForm">
        <h6 class="mb-3">New Message Template</h6>
        <div class="row g-3">
          <div class="col-md-4">
            <label class="form-label">Template Name</label>
            <input type="text" class="form-control" [(ngModel)]="form.name" placeholder="seasonal_offer" />
            <small class="text-muted">lowercase, digits and underscores only</small>
          </div>
          <div class="col-md-4">
            <label class="form-label">Language</label>
            <input type="text" class="form-control" [(ngModel)]="form.language" placeholder="en_US" />
          </div>
          <div class="col-md-4">
            <label class="form-label">Category</label>
            <select class="form-select" [(ngModel)]="form.category">
              <option value="MARKETING">MARKETING</option>
              <option value="UTILITY">UTILITY</option>
              <option value="AUTHENTICATION">AUTHENTICATION</option>
            </select>
          </div>
          <div class="col-md-4">
            <label class="form-label">Header</label>
            <select class="form-select" [(ngModel)]="form.headerType">
              <option value="none">None</option>
              <option value="text">Text</option>
              <option value="image">Image</option>
            </select>
          </div>
          <div class="col-md-8" *ngIf="form.headerType === 'text'">
            <label class="form-label">Header Text</label>
            <input type="text" class="form-control" [(ngModel)]="form.headerText" placeholder="Header text" />
          </div>
          <div class="col-md-8" *ngIf="form.headerType === 'image'">
            <label class="form-label">Header Image</label>
            <input type="file" class="form-control" accept="image/*"
              (change)="onHeaderImageSelected($event)" [disabled]="uploadingImage" />
            <small class="text-muted d-block mt-1" *ngIf="uploadingImage">Uploading image...</small>
            <small class="text-success d-block mt-1" *ngIf="imageHandle && !uploadingImage">
              Uploaded: {{ imageFileName }}
            </small>
          </div>
          <div class="col-md-12">
            <label class="form-label">Body</label>
            <textarea class="form-control" rows="3" [(ngModel)]="form.bodyText"
              placeholder="Hi {{ '{{' }}1{{ '}}' }}, get 20% off this week!"></textarea>
            <small class="text-muted">
              Use {{ '{{' }}1{{ '}}' }}, {{ '{{' }}2{{ '}}' }} for variables. A variable cannot be at the very start or end of the text.
            </small>
          </div>
          <div class="col-md-12" *ngIf="bodyVariableCount > 0">
            <label class="form-label">Example Values for Variables</label>
            <input type="text" class="form-control" [(ngModel)]="form.bodyExample"
              placeholder="e.g. Jugs, 20%" />
            <small class="text-muted">
              Comma-separated sample values for {{ '{{' }}1{{ '}}' }}..{{ '{{' }}{{ bodyVariableCount }}{{ '}}' }}, shown to Meta reviewers. Required for approval.
            </small>
          </div>
          <div class="col-md-12">
            <label class="form-label">Footer (optional)</label>
            <input type="text" class="form-control" [(ngModel)]="form.footerText" placeholder="Optional footer text" />
          </div>
        </div>
        <div class="mt-3">
          <button class="btn btn-success btn-sm" (click)="submitTemplate()" [disabled]="saving">
            {{ saving ? 'Submitting...' : 'Submit for Approval' }}
          </button>
        </div>
      </div>

      <!-- Templates table -->
      <div class="table-responsive">
        <table class="table table-hover align-middle">
          <thead>
            <tr>
              <th>Name</th>
              <th>Language</th>
              <th>Category</th>
              <th>Body</th>
              <th>Status</th>
              <th class="text-end">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="loading">
              <td colspan="6" class="text-center text-muted">Loading...</td>
            </tr>
            <tr *ngIf="!loading && templates.length === 0">
              <td colspan="6" class="text-center text-muted">No templates found.</td>
            </tr>
            <tr *ngFor="let t of templates">
              <td>{{ t.name }}</td>
              <td>{{ t.language }}</td>
              <td>{{ t.category }}</td>
              <td class="text-truncate" style="max-width: 320px;">{{ templateBodyPreview(t) }}</td>
              <td><span [class]="statusClass(t.status)">{{ t.status }}</span></td>
              <td class="text-end">
                <button class="btn btn-sm btn-outline-primary"
                  [disabled]="(t.status || '').toUpperCase() !== 'APPROVED'"
                  (click)="setupCampaign(t)">
                  Use in Campaign
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="d-flex justify-content-end gap-2">
        <button class="btn btn-sm btn-light" (click)="prevPage()" [disabled]="!beforeCursor || loading">Previous</button>
        <button class="btn btn-sm btn-light" (click)="nextPage()" [disabled]="!afterCursor || loading">Next</button>
      </div>

    </div>
  </div>
</div>
